// extracted by mini-css-extract-plugin
export default {"empty":"ProjectsEmpty_empty__OU4eV","title":"ProjectsEmpty_title__Wl4Zm","text":"ProjectsEmpty_text__mzfnr"};